var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStarOutlineYellow400(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76224 1.65881C8.83707 1.42849 9.16292 1.42848 9.23776 1.65881L10.5318 5.64159C10.7661 6.36263 11.4381 6.85081 12.1962 6.85081H16.3839C16.6261 6.85081 16.7268 7.16071 16.5309 7.30307L13.1429 9.76456C12.5296 10.2102 12.2729 11.0001 12.5072 11.7211L13.8013 15.7039C13.8761 15.9342 13.6125 16.1258 13.4166 15.9834L10.0286 13.5219C9.41527 13.0763 8.58473 13.0763 7.97138 13.5219L4.58342 15.9834C4.3875 16.1258 4.12387 15.9342 4.19871 15.7039L5.49279 11.7211C5.72707 11.0001 5.47042 10.2102 4.85707 9.76456L1.46911 7.30307C1.27319 7.16072 1.37388 6.85081 1.61606 6.85081H5.8038C6.56195 6.85081 7.23387 6.36263 7.46815 5.64159L8.76224 1.65881Z",
    stroke: "#FFBF00",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarOutlineYellow400);
export default __webpack_public_path__ + "static/media/icon_star_outline_yellow400.4a32354e0e20bf0f67ba28fb4eba5988.svg";
export { ForwardRef as ReactComponent };